export enum OrganizeTypes {
  REORGANIZE,
  REORGANIZE_AND_MOVE,
}